import * as React from 'react';
import Prices from "./Prices";

export default function CountryPrices() {
    return (
        <Prices isCountryPrice={true}/>
    );
}
